/*
 *
 * TermsAndConditionsDetailPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Feb-2025
 */

import React, {useState} from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import './TermsAndConditionsDetailPopup.scss'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalButton from '@nexidigital/portalbutton'
import PortalSwitch from '@nexidigital/portalswitch'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import { messages } from './languageModule'

const TermsAndConditionsDetailPopup = ({ actions, data: tac, isLoading }) => {
  const [status, setStatus] = useState(tac?.status)
  const intl = useIntl()

  return (
    <MerchantModal
      bigPopup
      topBarTitle={intl.formatMessage(messages.title)}
      onClose={() => actions.closePopup()}
      closeLabel={intl.formatMessage(messages.close)}
      withoutButton>
      <div className='termsAndConditionsDetailPopup'>
        <MerchantGenericCard 
          title={intl.formatMessage(messages.generalInformations)}
          toggle={tac?.category === 'CUSTOM' && (
            <PortalSwitch
              onChange={(val) => setStatus(val === true ? 'ACTIVE' : 'INACTIVE')}
              activeLabel={intl.formatMessage(messages.Enabled)}
              deactiveLabel={intl.formatMessage(messages.Disabled)}
              checked={status === 'ACTIVE' ?? false}
            />)
          }>
          <div className='termsAndConditionsDetailPopup_generalInfo text_field_section'>
            <PortalTextBlocked
              noPadding
              label={intl.formatMessage(messages.type).replace('*', '')}
              value={tac?.type && messages[tac.type] ? intl.formatMessage(messages[tac.type]) : ''}
            />
            <PortalTextBlocked noPadding label={intl.formatMessage(messages.name).replace('*', '')} value={tac?.name} />
            <PortalTextBlocked
              noPadding
              label={intl.formatMessage(messages.reservationType).replace('*', '')}
              value={tac?.reservationType && messages[tac.reservationType] ? intl.formatMessage(messages[tac.reservationType]) : ''}
            />
          </div>
        </MerchantGenericCard>
        <MerchantGenericCard title={intl.formatMessage(messages.termsCond)}>
          {tac?.termsAndConditions?.map((tac) => (
            <div className='termsAndConditionsDetailPopup_conditions' key={tac?.language}>
              <PortalTextBlocked
                noPadding
                label={intl.formatMessage(messages.language).replace('*', '')}
                value={tac?.language}
              />
              <PortalTextBlocked
                noPadding
                label={intl.formatMessage(messages.text).replace('*', '')}
                value={tac?.text}
              />
            </div>
          ))}
        </MerchantGenericCard>
        {tac?.category === 'CUSTOM' && (
          <div className='termsAndConditionsDetailPopup_removeBtn'>
            <PortalButton
              loading={isLoading}
              id='remove_terms_and_conditions'
              onClick={() => actions.doDeleteTac({ id: tac.id, status: status, type: tac.type })}
              label={intl.formatMessage(messages.confirm)}
              disabled={status === tac?.status}
            />
          </div>
        )}
      </div>
    </MerchantModal>
  )
}

TermsAndConditionsDetailPopup.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object,
  isLoading: PropTypes.bool
}

TermsAndConditionsDetailPopup.defaultProps = {
  actions: {},
  isLoading: false
}

export default TermsAndConditionsDetailPopup
